import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { isLoggedIn, logout } from "./services/axiosClient";
import OrthoLogo from "../src/assets/orthologo.png";

const Navbar = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const location = useLocation();

  const toggleDrawer = () => setShowDrawer(!showDrawer);

  useEffect(() => {
    // Adjust page content padding based on header height
    const header = document.querySelector(".fixed-header");
    if (header) {
      setHeaderHeight(header.offsetHeight);
    }
  }, []);

  // Close drawer automatically when route changes
  useEffect(() => {
    setShowDrawer(false);
  }, [location]);

  return (
    <>
      {/* Fixed Header */}
      <div className="w-100 position-fixed top-0 start-0 z-3">
        {/* Top Blue & Black Header */}
        <div className="top-header bg-dark d-flex text-white small d-none d-sm-flex">
          <div
            className="bg-primary py-2 px-4 d-flex align-items-center diagonal-left"
            style={{ flex: "0 0 60%" }}
          >
            <i className="bi bi-telephone-fill me-2"></i>
            Help Line:{" "}
            <b className="ms-1">
              <i>+91 7873366631 / +91 7873366632</i>
            </b>
          </div>
          <div
            className="bg-dark py-1 px-5 d-flex align-items-center diagonal-center"
            style={{ flex: "0 0 40%" }}
          >
            <i className="bi bi-envelope-fill me-2"></i>
            <a
              href="mailto:info@example.com"
              className="text-white text-decoration-none"
            >
              info.orthospinecare@gmail.com
            </a>
          </div>
        </div>

        {/* White Pill Navbar */}
        <div className="fixed-header ms-sm-0 ms-md-0 me-sm-0 me-md-0  bg-white shadow rounded-bottom">
          <div>
            <div className="navbar-pill px-4 py-2 d-flex justify-content-between align-items-center rounded-pill">
              {/* Logo */}
              <Link
                className="navbar-brand fw-bold d-flex align-items-center text-decoration-none"
                to="/"
              >
                {/* <i className="bi bi-heart-pulse-fill text-primary fs-4 me-2"></i> */}
                <img
                  src={OrthoLogo}
                  alt="Logo"
                  className="rounded-circle"
                  style={{ width: "50px", height: "50px", objectFit: "cover" }}
                />
                <span className="fs-5">Dr Puspak Samal </span>
              </Link>

              {/* Nav Links (Desktop) */}
              <div className="d-none d-xl-flex align-items-center flex-grow-1 justify-content-between ms-1">
                <ul className="nav text-[3rem]">
                  <li className="nav-item">
                    <Link className="nav-link text-[5rem]" to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-[3rem]" to="/about">
                      About
                    </Link>
                  </li>
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle text-[2rem]"
                      to="#"
                      id="informationDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Patient Education
                    </Link>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="informationDropdown"
                    >
                      <li>
                        <Link
                          className="dropdown-item text-[2rem]"
                          to="/spinal"
                        >
                          SPINAL
                        </Link>
                      </li>

                      <li>
                        <Link className="dropdown-item text-[2rem]" to="/err">
                          KNEE
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item text-[2rem]" to="/err">
                          HIP
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item text-[2rem]" to="/err">
                          TRAUMA & FRACTURE
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item text-[2rem]" to="/err">
                          ARTHOSCOPY & SPORTS MEDICINE
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item text-[2rem]" to="/err">
                          OSTEOPOROSIS
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link text-[2rem]" to="/blog">
                      Blogs
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-[2rem]" to="/contact">
                      Contact
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-[2rem]" to="/reminder">
                      Reminder
                    </Link>
                  </li>
                </ul>

                <div className="d-flex align-items-center">
                  {isLoggedIn() ? (
                    <>
                      <Link
                        className="btn btn-success rounded-pill px-4 text-uppercase fw-semibold text-[2rem]"
                        to=""
                        onClick={() => logout()}
                      >
                        Log out
                      </Link>
                    </>
                  ) : (
                    <>
                      <a
                        className="btn btn-success rounded-pill px-4 text-uppercase fw-semibold text-[2rem]"
                        href="https://indiahealthsystem.com/"
                      >
                        BOOK A APPOINTMENT
                      </a>
                    </>
                  )}
                </div>
              </div>

              {/* Toggle for Mobile */}
              <div className="d-lg-none">
                <button className="btn" onClick={toggleDrawer}>
                  <i className="bi bi-list fs-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Page Content Spacer */}
      <div style={{ height: `${headerHeight}px` }}></div>

      {/* Mobile Drawer */}
      <div
        className={`mobile-drawer position-fixed top-0 end-0 bg-white shadow p-4 h-100 ${
          showDrawer ? "open" : ""
        }`}
        style={{ width: "250px", zIndex: 1050 }}
      >
        <button className="btn-close mb-4" onClick={toggleDrawer}></button>
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link className="nav-link" to="/">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about">
              About
            </Link>
          </li>
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle"
              to="#"
              id="informationDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Patient Education
            </Link>
            <ul className="dropdown-menu" aria-labelledby="informationDropdown">
              {/* <li>
                        <Link className="dropdown-item" to="/cranial">
                         
                        </Link>
                      </li> */}
              <li>
                <Link className="dropdown-item" to="/spinal">
                  SPINAL
                </Link>
              </li>

              <li>
                <Link className="dropdown-item" to="/err">
                  KNEE
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/err">
                  HIP
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/err">
                  TRAUMA & FRACTURE
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/err">
                  ARTHOSCOPY & SPORTS MEDICINE
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/err">
                  OSTEOPOROSIS
                </Link>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <Link className="nav-link" to="/testimonial">
              Testimonial
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/blog">
              Blogs
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/contact">
              Contact
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/reminder">
              Reminder
            </Link>
          </li>
          <li className="nav-item mt-3">
            <a
              className="btn btn-success w-100"
              href="https://indiahealthsystem.com/"
            >
              BOOK A APPOINTMENT
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
